import React from "react"

const IframeEmbed = ({ embedCode }) => {
  if (!embedCode) return null

  return <div dangerouslySetInnerHTML={{ __html: embedCode }} />
}

export default IframeEmbed
